import { createFileRoute } from "@tanstack/react-router"
import { DocumentsPage } from "@/features/schema-management/pages/DocumentsPage"

export const Route = createFileRoute("/_authenticated/agent/document/")({
    component: DocumentsPage,
})
